import React from 'react';
import './warnings.scss';
import { ToolbarSimple } from '../../components';
import { ScrollView } from 'devextreme-react';

const Index = () => {
  return (
    <ScrollView className='view-wrapper-scroll'>
      <ToolbarSimple title='Alarmas'></ToolbarSimple>
    </ScrollView>
  );
};

export default Index;
